import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Send, CheckCircle2, Globe } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
export function ContactPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <main className="w-full pt-20" data-id="element-236">
      {/* Page Header */}
      <section className="bg-navy-900 py-20 relative overflow-hidden" data-id="element-237">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-238" />
        <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-239">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-240">
            Get in <span className="text-tech-green" data-id="element-241">Touch</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-300 max-w-2xl" data-id="element-242">
            Ready to transform your IT infrastructure? Our team of experts is
            here to help you build the future.
          </motion.p>
        </div>
      </section>

      <section className="py-24 bg-slate-50" data-id="element-243">
        <div className="max-w-7xl mx-auto px-4" data-id="element-244">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-245">
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border border-slate-100" data-id="element-246">
              <SectionHeading title="Start Your Project With Us" data-id="element-247" />

              {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-248">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-249">
                    <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-250" />
                  </div>
                  <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-251">
                    Message Sent!
                  </h3>
                  <p className="text-slate-600" data-id="element-252">
                    Thank you for reaching out. A member of our team will get
                    back to you within 24 hours.
                  </p>
                  <button onClick={() => setIsSubmitted(false)} className="mt-8 text-tech-blue font-semibold hover:text-tech-green transition-colors" data-id="element-253">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-254">
                  <div className="grid md:grid-cols-2 gap-6" data-id="element-255">
                    <div data-id="element-256">
                      <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-257">
                        Full Name
                      </label>
                      <input type="text" id="name" required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-tech-blue focus:border-transparent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="John Doe" data-id="element-258" />
                    </div>
                    <div data-id="element-259">
                      <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-260">
                        Email Address
                      </label>
                      <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-tech-blue focus:border-transparent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="john@company.com" data-id="element-261" />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6" data-id="element-262">
                    <div data-id="element-263">
                      <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-264">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-tech-blue focus:border-transparent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="+234 ..." data-id="element-265" />
                    </div>
                    <div data-id="element-266">
                      <label htmlFor="company" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-267">
                        Company
                      </label>
                      <input type="text" id="company" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-tech-blue focus:border-transparent outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Your Organization" data-id="element-268" />
                    </div>
                  </div>

                  <div data-id="element-269">
                    <label htmlFor="service" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-270">
                      Service of Interest
                    </label>
                    <select id="service" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-tech-blue focus:border-transparent outline-none transition-all bg-slate-50 focus:bg-white" data-id="element-271">
                      <option value="" data-id="element-272">Select a service...</option>
                      <option value="infrastructure" data-id="element-273">ICT Infrastructure</option>
                      <option value="integration" data-id="element-274">Systems Integration</option>
                      <option value="managed" data-id="element-275">Managed IT Services</option>
                      <option value="bpm" data-id="element-276">Business Process Management</option>
                      <option value="other" data-id="element-277">Other</option>
                    </select>
                  </div>

                  <div data-id="element-278">
                    <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-279">
                      Message
                    </label>
                    <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-tech-blue focus:border-transparent outline-none transition-all bg-slate-50 focus:bg-white resize-none" placeholder="Tell us about your project requirements..." data-id="element-280"></textarea>
                  </div>

                  <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-tech-green text-white rounded-xl font-bold text-lg hover:bg-emerald-400 transition-all shadow-lg hover:shadow-tech-green/50 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-281">
                    {isSubmitting ? <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-282" /> : <>
                        Send Message
                        <Send className="w-5 h-5" data-id="element-283" />
                      </>}
                  </button>
                </form>}
            </motion.div>

            {/* Contact Info & Map */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} className="space-y-8" data-id="element-284">
              <div className="bg-navy-900 rounded-3xl p-8 text-white shadow-xl" data-id="element-285">
                <h3 className="text-2xl font-bold mb-8" data-id="element-286">Contact Information</h3>

                <div className="space-y-6" data-id="element-287">
                  <div className="flex items-start gap-4" data-id="element-288">
                    <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center shrink-0" data-id="element-289">
                      <MapPin className="w-6 h-6 text-tech-green" data-id="element-290" />
                    </div>
                    <div data-id="element-291">
                      <h4 className="font-semibold text-lg mb-1" data-id="element-292">
                        Head Office
                      </h4>
                      <p className="text-slate-300 leading-relaxed" data-id="element-293">
                        Audu Ogbeh Street,
                        <br data-id="element-294" />
                        Jabi, Abuja,
                        <br data-id="element-295" />
                        Nigeria
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-296">
                    <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center shrink-0" data-id="element-297">
                      <Phone className="w-6 h-6 text-tech-green" data-id="element-298" />
                    </div>
                    <div data-id="element-299">
                      <h4 className="font-semibold text-lg mb-1" data-id="element-300">Phone</h4>
                      <p className="text-slate-300" data-id="element-301">0700-INVIGO</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-302">
                    <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center shrink-0" data-id="element-303">
                      <Mail className="w-6 h-6 text-tech-green" data-id="element-304" />
                    </div>
                    <div data-id="element-305">
                      <h4 className="font-semibold text-lg mb-1" data-id="element-306">Email</h4>
                      <p className="text-slate-300" data-id="element-307">info@invigoco.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-308">
                    <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center shrink-0" data-id="element-309">
                      <Globe className="w-6 h-6 text-tech-green" data-id="element-310" />
                    </div>
                    <div data-id="element-311">
                      <h4 className="font-semibold text-lg mb-1" data-id="element-312">Website</h4>
                      <a href="https://www.invigoco.com" target="_blank" rel="noopener noreferrer" className="text-tech-green hover:text-emerald-400 transition-colors" data-id="element-313">
                        www.invigoco.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-slate-200 rounded-3xl h-64 relative overflow-hidden group" data-id="element-314">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-315" />
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-316">
                  <div className="w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center mb-2 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-317">
                    <MapPin className="w-8 h-8 text-tech-blue" data-id="element-318" />
                  </div>
                  <span className="font-semibold text-slate-600 bg-white/80 px-4 py-1 rounded-full backdrop-blur-sm" data-id="element-319">
                    Jabi, Abuja, Nigeria
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>;
}